import axios from 'axios';

const API_BASE_URL = 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds timeout
});

// Request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response);
    return response;
  },
  (error) => {
    console.error('API Response Error:', error);
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timeout - please try again');
    }
    if (error.response?.status === 500) {
      throw new Error('Server error - please check your input');
    }
    if (!error.response) {
      throw new Error('Network error - please check if backend is running on port 8080');
    }
    throw error;
  }
);

export const compressionAPI = {
  // Compress text using specified algorithm
  compress: async (text, algorithm) => {
    try {
      const response = await api.post('/compress', {
        text: text,
        algorithm: algorithm.toUpperCase()
      });
      return response.data;
    } catch (error) {
      throw new Error(error.message || 'Compression failed');
    }
  },

  // Decompress using compressed data
  decompress: async (compressedData) => {
    try {
      const response = await api.post('/decompress', compressedData);
      return response.data;
    } catch (error) {
      throw new Error(error.message || 'Decompression failed');
    }
  }
};

export default api;
